export { default } from './mergeClasses';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/mergeClasses/index.js
// module id = 578
// module chunks = 2